import * as React from 'react';
import ListItem from '../list/ListItem';
import ListItemText from '../list/ListItemText';
import { classes, style } from 'typestyle';
import { leftPaddingStyle } from '../../../styles/input';
const SelectItem = ({ value, title, description, onClick, disabled = false, active = false, icon, className, }) => {
    return (React.createElement(ListItem, { small: true, hideLeftCell: !icon, className: classes(value, className, selectItemStyle, !icon && leftPaddingStyle), active: active, onClick: e => e && onClick && onClick(value), disabled: disabled, leftCell: icon, centerCell: React.createElement(ListItemText, { title: title, description: description }) }));
};
export default SelectItem;
const selectItemStyle = style({
    width: 'inherit',
});
//# sourceMappingURL=SelectItem.js.map